import { Fragment, useState } from "react";
import { IRotationModalProps } from "src/components/shared/Login/login.model";
import RotationModal from "src/components/shared/Login/RotationModal";
import useLoginUser from "src/components/shared/Login/useLoginUser";
import AuthorizationModal from "src/generator/_Modals/AuthorizationModal/AuthorizationModal";
import { useGetApi } from "src/hooks";
import { ICredentials } from "src/interfaces";
import { getYachtId } from "src/utils";

interface Props {
  opened: boolean;
  close: () => void;
}

export const usersMapper = (data: any) => {
  if (!data?.list || !Array.isArray(data.list)) return [];
  return data.list.map((user: any) => ({
    label: `${user.rolename} ${user.full_name}`,
    value: user.email,
    email: user.email,
  }));
};

const LoginModal = ({ opened, close }: Props) => {
  const [rotationModalProps, setRotationModalProps] =
    useState<IRotationModalProps>();

  const { handleLogin, isLoading } = useLoginUser({ setRotationModalProps });
  const { data: users } = useGetApi({
    request: "get-users-full",
    body: {
      params: {
        yachtid: getYachtId(),
      },
    },
    mapper: usersMapper,
    fetchOnInit: opened,
  });

  const handleAuthorizeGenericLogin = async (data: ICredentials) => {
    const params = {
      pass: data.pass,
      email: data.userid,
    };
    await handleLogin(params);
    location.reload();
  };

  return (
    <Fragment>
      <RotationModal
        {...rotationModalProps}
        onYes={d => handleAuthorizeGenericLogin(d)}
        close={() => setRotationModalProps({ open: false })}
      />
      <AuthorizationModal
        opened={opened}
        close={close}
        loading={isLoading}
        onSubmit={handleAuthorizeGenericLogin}
        users={users}
        title="Log in to authorized account"
        passOnly
      />
    </Fragment>
  );
};
export default LoginModal;
